<template>
    <div class="article-wrap">
        <h2 class="title">{{ article.title }}</h2>
        <div class="cttime">{{ timestampToMMDDYYYY(article.createtime) }}</div>

        <img :src="article.image" class="fenmian" alt="">

        <div class="content" v-html="article.content">

        </div>
        <ft></ft>
    </div>
</template>
<script>
import Fetch from "../../utils/fetch";
import ft from "../../components/ft.vue"
export default {
    name: 'App',
    data() {
        return {
            article: {}
        }
    },
    updated() {

    },
    components: {
        ft
    },
    mounted() {
        Fetch("/user/article_by_id", { article_id: this.$route.params.code }).then(res => {
            console.log(res);
            this.article = res.data;
        })

    },
    methods: {
        timestampToMMDDYYYY(timestamp) {
            const date = new Date(timestamp * 1000); // 将秒级时间戳转换为毫秒级
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1，并且保证两位数格式
            const day = date.getDate().toString().padStart(2, '0'); // 天数保证两位数格式
            const year = date.getFullYear();

            return `${month}/${day}/${year}`;
        }
    }
}
</script>
<style scoped>
.fenmian {
    display: block;
    width: 90%;
    margin: 0 auto;
}

.content {
    padding: 10px 8%;
    color: white
}

.cttime {
    font-size: 0.35rem;
    margin-top: 10px;
    color: gray;
    padding: 0 15px;
    color: white;
    font-size: 0.35rem;
}

.title {
    margin-top: 15px;
    color: gold;
    padding: 0 15px;
    line-height: 0.5rem;
    font-size: 0.4rem;
}

.article-wrap {
    min-height: 100vh;
    background: url("../images/vip/vip.png");
}
</style>